import { EventBus, EventType } from 'scbk-services/event-bus/bus/event-bus';

let initStorage = false;
/**
 *
 */
function initLocalStorage() {
    if (initStorage) {
        return;
    }

    if (typeof window === 'undefined' || !window.localStorage) {
        console.log('##### localStorage undefined');
        return;
    }

    initStorage = true;

    const setItem = window.localStorage.setItem.bind(window.localStorage);
    const getItem = window.localStorage.getItem.bind(window.localStorage);
    const removeItem = window.localStorage.removeItem.bind(window.localStorage);
    const clear = window.localStorage.clear.bind(window.localStorage);

    console.log('##### localStorage');

    /**
     *
     * @param key
     * @param value
     */
    window.localStorage.setItem = function (key: string, value: string) {
        //console.log('##### localStorage setItem');
        setItem(key, value);

        queueMicrotask(() => {
            EventBus.getInstance().emit(EventType.SetItemLocalStorage, [key, value]);
        });
    };

    /**
     *
     * @param key
     * @returns
     */
    window.localStorage.getItem = function (key: string) {
        //console.log('##### localStorage getItem');

        queueMicrotask(() => {
            EventBus.getInstance().emit(EventType.GetItemLocalStorage, [key]);
        });
        return getItem(key);
    };

    /**
     *
     * @param key
     */
    window.localStorage.removeItem = function (key: string) {
        //console.log('##### localStorage removeItem');
        removeItem(key);

        queueMicrotask(() => {
            EventBus.getInstance().emit(EventType.RemoveItemLocalStorage, [key]);
        });
    };

    window.localStorage.clear = function () {
        clear();

        queueMicrotask(() => {
            EventBus.getInstance().emit(EventType.ClearLocalStorage);
        });
    };
}

export { initLocalStorage };
